import React from "react";
import { Alert } from "@mui/material";
import useAlertNotification from "./useAlertNotification";
import AlertNotificationGroup from "./AlertNotificationGroup";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const AlertNotificationModal = ({ open, notes, handleReportNote }) => {
  const {
    configs,
    onClose,
    submitting,
    isDisabled,
    configGroups,
    messageContents,
    areAllMessagesValid,
    selectedRecipients,
    areEmailRecipientsSelected,
    handleMessageChange,
    handleRecipientsChange,
    handleSaveReportNotes,
    handleAddNoteToMessage,
  } = useAlertNotification({ notes, handleReportNote });

  return (
    <ModalWrapper
      show={open}
      title="Do you want to send notification for alert changes?"
      onClose={onClose}
      maxWidth="md"
      actionButtons={[
        {
          label: "Skip",
          variant: "outlined",
          color: "secondary",
          className: "mr-2",
          onClick: () => handleSaveReportNotes(false),
          isLoading: submitting.withoutNotify,
          disabled: isDisabled,
        },
        {
          label: "Confirm",
          onClick: () => handleSaveReportNotes(true),
          isLoading: submitting.withNotify,
          disabled:
            !areAllMessagesValid || !areEmailRecipientsSelected || isDisabled,
        },
      ]}
    >
      <div className="d-flex flex-column">
        {configs.length > 1 && (
          <Alert severity="info" className="mb-3">
            Alert notifications will be sent via {configs.length} methods (
            {configs.map((c) => c.notification_method).join(", ")})
          </Alert>
        )}

        {configGroups.map((group) => (
          <AlertNotificationGroup
            key={group.messageKey}
            group={group}
            message={messageContents[group.messageKey] || ""}
            isDisabled={isDisabled}
            selectedRecipients={selectedRecipients[group.messageKey]}
            handleRecipientsChange={(recipients) =>
              handleRecipientsChange(group.messageKey, recipients)
            }
            handleMessageChange={handleMessageChange}
            handleAddNoteToMessage={handleAddNoteToMessage}
          />
        ))}
      </div>
    </ModalWrapper>
  );
};

export default AlertNotificationModal;
